import { useRef } from 'react';
import FindStudentList from "@/pages/comp/basic/student/frame/left_find_list";
import ReportList from "./report_list";

function DailyPrescribeHistoryArea() {
  const findStudentListRef = useRef<any>(null);
  const ReportListRef = useRef<any>(null);

  return (
    <div className="flex flex-row" style={{ gap: 5 }}>
      <div style={{ minWidth: 230 }} >
        <FindStudentList
          ref={findStudentListRef}
          list={(inData: any) => {
            if (ReportListRef.current) {
              let s_stu_user_seq: any = [];
              if (inData.s_stu_user_seq) {
                s_stu_user_seq = inData.s_stu_user_seq;
              }

              ReportListRef.current.list({
                "now_page": "1",
                "s_stu_seq": s_stu_user_seq,
                ...inData
              });
            }
          }}
          grid_opt={{
            rowMultiSelectWithClick: true,
          }}
        ></FindStudentList>
      </div>
      <div style={{ flexGrow: 1, minWidth: 400 }}>
        <ReportList
          ref={ReportListRef}
        ></ReportList>
      </div>
    </div>
  );
};
export default DailyPrescribeHistoryArea;